import React from 'react';
import { Music, Instagram, Twitter, Youtube, Cloud } from 'lucide-react';
import { socialLinks } from '../mock';

const iconMap = {
  Music,
  Instagram,
  Twitter,
  Youtube,
  Cloud
};

const SocialLinks = () => {
  return (
    <div className="social-links">
      {socialLinks.map((social) => {
        const Icon = iconMap[social.icon];
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
            aria-label={social.name}
          >
            <Icon size={20} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
